import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';

/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import ResetPasswordPage from '@scenes/ResetPasswordPage';

/* Constants */
import { PAGE_TYPE_RESET_PASSWORD } from '@constants/pages';

/* Types */
import { Children } from 'types/base.types';

function ResetPasswordPageScene(): Children {
  return (
    <>
      <Head>{generateNextSeo({ title: 'Reset Password' })}</Head>
      <ResetPasswordPage />;
    </>
  );
}

ResetPasswordPageScene.pageAttributes = { page: PAGE_TYPE_RESET_PASSWORD };
ResetPasswordPageScene.Layout = getLayout({ promo: false, footer: false });

export default ResetPasswordPageScene;
